import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from "react-router-dom";

export default function BackButton() {

    const navigation = useNavigate()

    function goBack() {
        navigation(-1)
    }

    return (    
        <i role="button" className="text-white fa-solid fa-chevron-left" style={{ fontSize:"25px"}}  onClick={() => goBack()}></i>    
    )
}